export default __webpack_public_path__ + "static/media/bv-product-new.5bb8cb14.svg";